<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ detail.address_street.toUpperCase() }},
                {{ detail.state.name.toUpperCase() }},
                {{ detail.city.toUpperCase() }}, {{ detail.zip_code }}
              </h4>

              <form
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="TeotLPfqrpACMj4HlrJuJXIHIMK8TQxPAIjCclyaDNxbrvPkGApHGgBaqOx8xDTc"
                />

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="address_street_id">Address Street*</label>
                    <input
                      type="text"
                      name="address_street"
                      value="100 EAGLES LNDG"
                      id="address_street_id"
                      class="form-control"
                      maxlength="255"
                      required=""
                      v-model.trim="$v.address_street.$model"
                    />
                    <div
                      v-if="submitted && !$v.address_street.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->

                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="zip_code_id">ZIP Code*</label>
                    <input
                      type="text"
                      name="zip_code"
                      value="30143"
                      id="zip_code_id"
                      class="form-control"
                      maxlength="10"
                      required=""
                      v-model.trim="$v.zip_code.$model"
                    />
                    <div
                      v-if="submitted && !$v.zip_code.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="city_id">City*</label>
                    <input
                      type="text"
                      name="city"
                      value="JASPER"
                      id="city_id"
                      class="form-control"
                      maxlength="255"
                      required=""
                      v-model.trim="$v.city.$model"
                    />
                    <div
                      v-if="submitted && !$v.city.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->

                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="state_id">State*</label>
                    <v-select
                      v-model.trim="$v.state.$model"
                      :options="options"
                    ></v-select>
                    <div
                      v-if="submitted && !$v.state.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="longitude_id">Longitude</label>
                    <input
                      type="number"
                      name="longitude"
                      id="longitude_id"
                      class="form-control"
                      step="any"
                      v-model="lng"
                    />
                  </div>
                  <!-- End Col -->

                  <!-- Start Col -->
                  <div class="col-lg-6">
                    <label for="latitude_id">Latitude</label>
                    <input
                      type="number"
                      name="latitude"
                      id="latitude_id"
                      class="form-control"
                      step="any"
                      v-model="lat"
                    />
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Button -->
                <div class="d-flex flex-wrap gap-2">
                  <button
                    class="btn btn-success"
                    :disabled="loadingAction"
                    type="submit"
                  >
                    Save
                  </button>
                  <button type="button" class="btn btn-light waves-effect">
                    <router-link
                      :to="'/mpg/addresses/' + detail.address_id + '/details'"
                      >Cancel</router-link
                    >
                  </button>
                </div>
                <!-- End Button -->
              </form>
              <!-- End Form -->
              <!-- End Form -->
            </div>
            <!-- End Card Body -->
          </div>
          <!-- End Card -->
        </div>
        <!-- End Col -->
      </div>
    </template>
  </div>
</template>

<script>
import { addressesService } from '../services/addresses.service'
import { utilService } from '../services/util.service'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { router } from '../router'

export default {
  name: 'EditAddresses',
  components: {},
  data () {
    return {
      submitted: false,
      loading: true,
      loadingAction: false,
      error: '',
      detail: {},
      state: '',
      options: [],
      address_street: '',
      zip_code: '',
      city: '',
      lat: '',
      lng: ''
    }
  },
  validations: {
    state: { required },
    zip_code: { required },
    address_street: { required },
    city: { required }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      router.push('/mpg/addresses/')
    }
    utilService.getState().then((states) => {
      this.options = states.results.map((e) => {
        e.label = e.acronym
        e.code = e.state_id
        return e
      })
      addressesService.getDataById(this.$route.params.id).then((rs) => {
        this.detail = rs
        this.state = this.options.find(e => e.state_id === this.detail.state.state_id)
        this.address_street = this.detail.address_street
        this.zip_code = this.detail.zip_code
        this.city = this.detail.city
        this.lat = this.detail.latitude
        this.lng = this.detail.lng
        this.loading = false
      })
    })
  },
  methods: {
    moment,
    onSubmit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loadingAction = true
      const payload = {
        address_street: this.address_street,
        city: this.city,
        zip_code: this.zip_code,
        latitude: this.lat,
        longitude: this.lng,
        state: this.state.code
      }
      addressesService.update(payload, this.$route.params.id).then(
        (rs) => {
          this.$nextTick(() => {
            router.push(
              `/mpg/addresses/${this.$route.params.id}/details/`
            )
          })
        },
        (error) => {
          this.error = error
          this.loadingAction = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EditAddresses.vue